// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

import api from '../../../services/api';


const validateMobileService = async (data) => {
  return api('https://api.craftyclicks.co.uk/phone/1.1/validate', data, 'POST');
};

const validateEmailService = async (data) => {
  return api('https://api.craftyclicks.co.uk/email/1.1/validate', data, 'POST');
};

const confirmOrderForBookshopService = async (data) => {
  return api(`/Sellitback.svc/CreateOrder?CustomerId=${data
    .CustomerID}&CartID=${data.CartID}&Token=${data.Token}&PaymentType=1&Voucher=0`, {}, 'GET');
};

const completingConfirmForBookshop = async (data) => {
  return api('/Sellitback.svc/CompletingConfirmForBookshop',
    { ...data },
    'POST');
};

const validateDiscountCodeService = async (data) => {
  return api('/Sellitback.svc/ApplyDiscount', { ...data }, 'POST');
};

export {
  validateMobileService,
  validateEmailService,
  confirmOrderForBookshopService,
  completingConfirmForBookshop,
  validateDiscountCodeService,
};
